import { ApolloError, ServerError } from "@apollo/client";

export function useGraphqlErrors() {
  function getErrorMessages(error: ApolloError): string[] {
    if (!error) return [];

    const serverError = error.networkError as ServerError | undefined;
    const result = serverError?.result;
    const errorMessages =
      result && typeof result === "object" && "errors" in result
        ? result.errors.flatMap((err: any) => err.message)
        : [];
    return errorMessages;
  }

  return { getErrorMessages };
}
